<script setup>
import SocialLoginButton from '@/components/account/SocialLoginButton.vue';

const props = defineProps({
  type: {
    type: String,
    default: 'login',
  },
});
</script>

<template>
  <div class="space-y-6 py-2">
    <p class="text-center font-medium">{{ $t('auth.joinWithSocialMedia') }}</p>
    <div class="space-x-4 flex">
      <SocialLoginButton provider="google" />
      <SocialLoginButton provider="facebook" />
      <SocialLoginButton provider="apple" />
    </div>

    <div class="relative">
      <div class="absolute inset-0 flex items-center">
        <div class="w-full border-t border-blackly"></div>
      </div>
      <div class="relative flex justify-center text-sm">
        <span class="px-2 bg-white text-blackly">
          {{ props.type === 'login' ? $t('common.or') : $t('auth.orContinueWithEmail') }}
        </span>
      </div>
    </div>
  </div>
</template>
